"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateFormOptionsResponseSchema = exports.estimateListResponseSchema = exports.estimateDetailSchema = exports.estimateSummarySchema = exports.estimateVersionListResponseSchema = exports.estimateVersionSchema = exports.estimateVersionDocumentSchema = exports.estimateVersionSummarySchema = exports.estimateDeliverySchema = exports.estimateActivitySchema = exports.estimateActivityTypeSchema = exports.estimateApprovalSchema = exports.estimateRecipientSchema = exports.estimateLineSchema = exports.updateEstimateStatusRequestSchema = exports.recordEstimateDeliveryEventRequestSchema = exports.manualEstimateApprovalRequestSchema = exports.updateEstimateRequestSchema = exports.createEstimateRequestSchema = exports.estimateLineInputSchema = exports.estimateStatusSchema = exports.estimateIdSchema = void 0;
const zod_1 = require("zod");
const catalog_1 = require("./catalog");
const customer_1 = require("./customer");
const job_1 = require("./job");
const pagination_1 = require("./pagination");
const team_1 = require("./team");
const optionalTrimmedString = (maxLength) => zod_1.z
    .string()
    .trim()
    .max(maxLength)
    .optional()
    .transform((value) => value || undefined);
exports.estimateIdSchema = zod_1.z.string().uuid();
exports.estimateStatusSchema = zod_1.z.enum([
    "DRAFT",
    "SENT",
    "ACCEPTED",
    "DECLINED",
]);
exports.estimateLineInputSchema = zod_1.z.object({
    catalogItemId: zod_1.z.string().uuid(),
    quantityMilli: zod_1.z.number().int().min(1).max(1_000_000),
});
const estimateInputSchema = zod_1.z
    .object({
    customerId: zod_1.z.string().uuid(),
    serviceLocationId: zod_1.z.string().uuid(),
    recipientContactId: zod_1.z.string().uuid().optional(),
    notes: optionalTrimmedString(5_000),
    expiresAt: zod_1.z.string().datetime().optional(),
    taxRateMilliPercent: zod_1.z.number().int().min(0).max(100_000),
    lines: zod_1.z.array(exports.estimateLineInputSchema).min(1).max(100),
})
    .superRefine((value, context) => {
    const seen = new Set();
    value.lines.forEach((line, index) => {
        if (seen.has(line.catalogItemId)) {
            context.addIssue({
                code: "custom",
                path: ["lines", index, "catalogItemId"],
                message: "Each pricebook item can appear only once.",
            });
        }
        seen.add(line.catalogItemId);
    });
});
exports.createEstimateRequestSchema = estimateInputSchema.and(zod_1.z.object({ appointment: job_1.appointmentInputSchema.optional() }));
exports.updateEstimateRequestSchema = estimateInputSchema;
exports.manualEstimateApprovalRequestSchema = zod_1.z.object({
    note: optionalTrimmedString(1_000),
});
exports.recordEstimateDeliveryEventRequestSchema = zod_1.z.discriminatedUnion("status", [
    zod_1.z.object({ status: zod_1.z.literal("DELIVERED") }),
    zod_1.z.object({ status: zod_1.z.literal("VIEWED") }),
    zod_1.z.object({
        status: zod_1.z.literal("FAILED"),
        reason: zod_1.z.string().trim().min(1).max(2_000),
    }),
]);
exports.updateEstimateStatusRequestSchema = zod_1.z.discriminatedUnion("status", [
    zod_1.z.object({ status: zod_1.z.literal("SENT") }),
    zod_1.z.object({ status: zod_1.z.literal("DECLINED") }),
    zod_1.z.object({
        status: zod_1.z.literal("ACCEPTED"),
        note: optionalTrimmedString(1_000),
    }),
]);
exports.estimateLineSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    catalogItemId: zod_1.z.string().uuid(),
    position: zod_1.z.number().int().nonnegative(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    pricingUnit: zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]),
    quantityMilli: zod_1.z.number().int().positive(),
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    unitCostCents: zod_1.z.number().int().nonnegative().nullable(),
    taxable: zod_1.z.boolean(),
    lineTotalCents: zod_1.z.number().int().nonnegative(),
    priceBookVersionId: zod_1.z.string().uuid().nullable().optional(),
});
exports.estimateRecipientSchema = zod_1.z.object({
    contactId: zod_1.z.string().uuid().nullable(),
    name: zod_1.z.string(),
    email: zod_1.z.string().email().nullable(),
    phone: zod_1.z.string().nullable(),
    preferredChannel: customer_1.communicationChannelSchema,
    smsConsentStatus: customer_1.smsConsentStatusSchema,
});
exports.estimateApprovalSchema = zod_1.z.object({
    source: zod_1.z.enum(["STAFF", "CUSTOMER_SIGNATURE"]),
    actorSubject: zod_1.z.string().nullable(),
    actorName: zod_1.z.string().nullable(),
    note: zod_1.z.string().nullable(),
    approvedAt: zod_1.z.string().datetime(),
});
exports.estimateActivityTypeSchema = zod_1.z.enum([
    "CREATED",
    "UPDATED",
    "VERSION_CREATED",
    "DELIVERY_QUEUED",
    "SENT",
    "DELIVERED",
    "VIEWED",
    "APPROVED",
    "DECLINED",
    "CONVERTED",
    "DELIVERY_FAILED",
]);
exports.estimateActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: exports.estimateActivityTypeSchema,
    actorType: zod_1.z.enum(["STAFF", "CUSTOMER", "SYSTEM", "PROVIDER"]),
    actorSubject: zod_1.z.string().nullable(),
    actorName: zod_1.z.string().nullable(),
    detail: zod_1.z.string().nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    occurredAt: zod_1.z.string().datetime(),
});
exports.estimateDeliverySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    versionId: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    channel: customer_1.communicationChannelSchema,
    status: zod_1.z.enum(["QUEUED", "SENT", "DELIVERED", "VIEWED", "FAILED"]),
    provider: zod_1.z.string(),
    providerMessageId: zod_1.z.string().nullable(),
    failureReason: zod_1.z.string().nullable(),
    requestedAt: zod_1.z.string().datetime(),
    sentAt: zod_1.z.string().datetime().nullable(),
    deliveredAt: zod_1.z.string().datetime().nullable(),
    viewedAt: zod_1.z.string().datetime().nullable(),
    failedAt: zod_1.z.string().datetime().nullable(),
});
exports.estimateVersionSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    contentHash: zod_1.z.string().length(64),
    createdBySubject: zod_1.z.string().nullable(),
    createdByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime(),
});
exports.estimateVersionDocumentSchema = zod_1.z.object({
    estimateId: exports.estimateIdSchema,
    estimateNumber: zod_1.z.number().int().positive(),
    versionNumber: zod_1.z.number().int().positive(),
    business: zod_1.z.object({
        name: zod_1.z.string(),
        logoUrl: zod_1.z.string().url().nullable(),
        contactEmail: zod_1.z.string().email().nullable(),
        phone: zod_1.z.string().nullable(),
        address: zod_1.z.object({
            name: zod_1.z.string(),
            addressLine1: zod_1.z.string(),
            addressLine2: zod_1.z.string().nullable(),
            city: zod_1.z.string(),
            state: zod_1.z.string().length(2),
            postalCode: zod_1.z.string(),
            country: zod_1.z.literal("US"),
        }),
    }),
    customer: job_1.jobCustomerSchema,
    serviceLocation: job_1.jobServiceLocationSchema,
    recipient: exports.estimateRecipientSchema,
    notes: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.estimateLineSchema.omit({ id: true })),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxRateMilliPercent: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    totalCents: zod_1.z.number().int().nonnegative(),
    expiresAt: zod_1.z.string().datetime().nullable(),
    termsAndConditions: zod_1.z.string(),
    issuedAt: zod_1.z.string().datetime(),
});
exports.estimateVersionSchema = exports.estimateVersionSummarySchema.extend({
    document: exports.estimateVersionDocumentSchema,
});
exports.estimateVersionListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.estimateVersionSummarySchema),
});
exports.estimateSummarySchema = zod_1.z.object({
    id: exports.estimateIdSchema,
    estimateNumber: zod_1.z.number().int().positive(),
    status: exports.estimateStatusSchema,
    customer: job_1.jobCustomerSchema,
    serviceLocation: job_1.jobServiceLocationSchema,
    recipient: exports.estimateRecipientSchema.nullable(),
    currentVersionNumber: zod_1.z.number().int().nonnegative(),
    approval: exports.estimateApprovalSchema.nullable(),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxRateMilliPercent: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    totalCents: zod_1.z.number().int().nonnegative(),
    expiresAt: zod_1.z.string().datetime().nullable(),
    sentAt: zod_1.z.string().datetime().nullable(),
    acceptedAt: zod_1.z.string().datetime().nullable(),
    declinedAt: zod_1.z.string().datetime().nullable(),
    appointment: zod_1.z
        .object({
        startAt: zod_1.z.string().datetime(),
        endAt: zod_1.z.string().datetime(),
        assignedMembershipId: zod_1.z.string().uuid().nullable(),
    })
        .nullable()
        .default(null),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.estimateDetailSchema = exports.estimateSummarySchema.extend({
    notes: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.estimateLineSchema),
    activities: zod_1.z.array(exports.estimateActivitySchema),
    deliveries: zod_1.z.array(exports.estimateDeliverySchema),
    versions: zod_1.z.array(exports.estimateVersionSummarySchema),
});
exports.estimateListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.estimateSummarySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
exports.estimateFormOptionsResponseSchema = zod_1.z.object({
    customers: zod_1.z.array(job_1.jobCustomerSchema.extend({
        contacts: zod_1.z.array(customer_1.customerContactSchema),
        locations: zod_1.z.array(job_1.jobServiceLocationSchema),
    })),
    catalogItems: zod_1.z.array(catalog_1.catalogItemSchema),
    teamMembers: zod_1.z.array(team_1.teamMemberSchema).default([]),
});
//# sourceMappingURL=estimate.js.map